var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 56,
    viewBox: "0 0 61 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2941_9206)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 45,
    height: 40,
    rx: 8,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6086 31.858L29.6083 31.8582C28.7175 32.7489 27.5093 33.2493 26.2495 33.2493C24.9897 33.2492 23.7816 32.7487 22.8908 31.8578C22.0001 30.967 21.4997 29.7588 21.4998 28.499C21.4998 27.2392 22.0003 26.0311 22.8912 25.1403L22.8912 25.1403L22.8936 25.1379L32.2 15.7018C32.5009 15.3968 32.8592 15.1543 33.2542 14.9883C33.6491 14.8223 34.073 14.736 34.5015 14.7344C34.9299 14.7328 35.3544 14.8159 35.7506 14.979C36.1468 15.1421 36.5069 15.3819 36.81 15.6847C37.1132 15.9874 37.3535 16.3471 37.5171 16.7431L37.9792 16.5521L37.5172 16.7431C37.6808 17.139 37.7645 17.5635 37.7635 17.9919C37.7625 18.4203 37.6768 18.8444 37.5114 19.2396C37.3459 19.6348 37.1039 19.9934 36.7993 20.2947L36.7993 20.2947L36.795 20.299L27.4898 29.7341C27.4896 29.7342 27.4895 29.7344 27.4893 29.7346C27.3273 29.8977 27.1346 30.0273 26.9224 30.1159L27.1152 30.5773L26.9224 30.1159C26.7101 30.2046 26.4822 30.2506 26.2521 30.2511C26.0219 30.2517 25.7939 30.2068 25.5811 30.1191C25.3683 30.0314 25.1748 29.9025 25.0119 29.74C24.8489 29.5774 24.7197 29.3843 24.6315 29.1717C24.5433 28.9591 24.4979 28.7311 24.4979 28.501C24.4979 28.2708 24.5434 28.0429 24.6316 27.8303C24.7198 27.6177 24.8491 27.4246 25.0121 27.2621L25.0121 27.2621L25.0155 27.2587L32.8186 19.326C32.8189 19.3257 32.8193 19.3253 32.8196 19.325C32.8661 19.2789 32.9289 19.2529 32.9944 19.2527C33.0604 19.2524 33.1238 19.2782 33.1708 19.3244C33.2178 19.3707 33.2447 19.4337 33.2455 19.4997C33.2463 19.5652 33.2213 19.6284 33.176 19.6756C33.1757 19.676 33.1753 19.6763 33.175 19.6766L25.371 27.6102C25.2547 27.7244 25.1617 27.8603 25.0975 28.0103C25.0325 28.1622 24.9982 28.3255 24.9966 28.4907C24.9951 28.6559 25.0263 28.8199 25.0885 28.9729C25.1507 29.126 25.2427 29.2653 25.359 29.3826C25.4754 29.4999 25.6138 29.593 25.7664 29.6565C25.919 29.72 26.0826 29.7526 26.2479 29.7524C26.4131 29.7522 26.5767 29.7193 26.7291 29.6555C26.8816 29.5917 27.0198 29.4983 27.1359 29.3807L27.1362 29.3805L36.441 19.9462C36.6967 19.6918 36.9 19.3895 37.039 19.0565C37.1784 18.7228 37.2507 18.3648 37.2515 18.0031C37.2524 17.6414 37.1819 17.2831 37.0441 16.9487C36.9062 16.6142 36.7038 16.3103 36.4483 16.0542C36.1928 15.7982 35.8894 15.595 35.5553 15.4564C35.2212 15.3179 34.863 15.2465 34.5013 15.2466C34.1396 15.2466 33.7814 15.318 33.4474 15.4566C33.1133 15.5953 32.8099 15.7985 32.5544 16.0546L32.5525 16.0566L23.2486 25.4898C23.2481 25.4903 23.2477 25.4907 23.2472 25.4912C22.8529 25.8853 22.54 26.3531 22.3263 26.868C22.1123 27.3835 22.002 27.9361 22.0016 28.4942C22.0008 29.6214 22.4478 30.7027 23.2443 31.5003C24.0408 32.2979 25.1215 32.7465 26.2487 32.7473C27.3759 32.7481 28.4573 32.3011 29.2549 31.5046L29.2549 31.5046L36.9477 23.8218L36.9478 23.8217C36.971 23.7985 36.9986 23.7801 37.0289 23.7675C37.0592 23.755 37.0918 23.7486 37.1246 23.7486C37.1574 23.7486 37.1899 23.7551 37.2202 23.7677C37.2505 23.7802 37.2781 23.7987 37.3013 23.8219L37.6551 23.4686L37.3013 23.8219C37.3481 23.8688 37.3744 23.9324 37.3744 23.9987C37.3743 24.065 37.3479 24.1286 37.301 24.1754L29.6086 31.858Z",
    fill: "black",
    stroke: "#524F4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2941_9206",
    x: 0,
    y: 0,
    width: 61,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2941_9206"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2941_9206",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5825cca3dfb8759b96d7fb2291b4ac48.svg";
export { ForwardRef as ReactComponent };